import { PageFooter } from "@/components/molecules/PageFooter";
import { IntroductionSection } from "@/components/organisms/IntroductionSection";
import { QuestionsListSection } from "@/features/question/components/organisms/QuestionsListSection";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useSurveyStore } from "@/lib/zustand/useStore";
import { Link, useParams } from "react-router-dom";

export function ManageSurvey() {
    const { orgId, projectId, surveyId } = useParams();
    const { survey } = useSurveyStore();

    return (
        <>
            <div className="flex items-stretch flex-1 gap-2">
                <IntroductionSection description={survey?.description} />

                <Separator orientation="vertical" />

                <QuestionsListSection />
            </div>

            <PageFooter>
                <div>
                    <Link to={`/organization/${orgId}/project/${projectId}/survey/${surveyId}/manage-survey/questions`}>
                        <Button
                            size="sm"
                        >
                            Open Survey
                        </Button>
                    </Link>
                </div>
            </PageFooter>
        </>
    )
}
